import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ds from 'designsystem';
import { inject, observer } from 'mobx-react';
import { BlogArticle as BlogArticleModel } from 'models';
import ANCHOR from 'common/consts/anchor';
import Link from 'blocks/StyledLink';
import { underscoresToDashes } from 'common/methods/string';
import Header4 from 'elements/Header4';
import { Bind } from 'lodash-decorators';
import Icon from './Icon';

const Wrapper = styled.div`
  margin:${ds.get('metrics.s')} 0;
  opacity: ${({ fadeInArticle }) => (fadeInArticle ? 1 : 0)};
  transition-duration: 0.3s;
`;

const Title = styled(Header4)`
  margin-top: ${ds.get('metrics.s')};
`;

const ImageMemory = styled.img`
  display: none;
`;

@inject('windowStore', 'appStore')
@observer
class BlogArticleBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageIsLoaded: false,
    };
  }

  @Bind()
  setImageIsLoaded() {
    this.setState({
      imageIsLoaded: true,
    });
  }

  render() {
    const {
      article: {
        listingImage,
        title,
        slug,
        mainCategory: {
          codename,
        },
      },
      windowStore,
      appStore: {
        currentLanguage,
      },
    } = this.props;

    const { imageIsLoaded } = this.state;
    const articleCategory = underscoresToDashes(codename);

    return (
      <Wrapper fadeInArticle={imageIsLoaded}>
        <Link to={{
          pathname: `${ANCHOR.BLOG[currentLanguage]}/${articleCategory}/${slug}`,
          state: { slug },
        }}
        >
          <ImageMemory
            src={windowStore.adjustImageSize(listingImage)}
            onLoad={this.setImageIsLoaded}
          />
          <Icon
            url={windowStore.adjustImageSize(listingImage)}
          />
          <Title>
            {title}
          </Title>
        </Link>
      </Wrapper>
    );
  }
}

BlogArticleBox.propTypes = {
  article: PropTypes.instanceOf(BlogArticleModel).isRequired,
};

export default BlogArticleBox;



// WEBPACK FOOTER //
// ./src/pages/Blog/BlogArticleBox/index.jsx